import { showLoading, stopLoading } from '../components/loading';


const toogleMenuCheckoutWhenClick = () => {
  const chekoutClickableButton = $('.menu-checkout__icon');
  const checkoutButton = $('.menu-checkout');

  chekoutClickableButton.on('click', function () {
    const checkoutEmpty = (parseInt($('.menu-checkout').attr('data-item'), 10) === 0);

    if (checkoutEmpty) {
      checkoutButton.toggleClass('menu-checkout--empty');
    } else {
      checkoutButton.toggleClass('menu-checkout--items');
    }
  });
};

const closeCartMenu = () => {
  const checkoutButton = $('.menu-checkout');

  checkoutButton.removeClass('menu-checkout--items');
  checkoutButton.removeClass('menu-checkout--empty');
  checkoutButton.removeClass('menu-checkout--model');
};

const removeFromCartWhenClick = () => {
  const removeFromCartButton = $('.remove_cart_item');
  removeFromCartButton.on('click', function (e) {
    const url = $(this).data('url');
    const li = $(this).closest('li');

    $.getJSON(url, function (data) {
      if (data.success) {
        const checkoutButton = $('.menu-checkout');
        const items = $('.add_cart_button');
        checkoutButton.attr('data-item', data.count);

        items.each((i) => {
          if (items[i].dataset.currentItem
              === e.target.dataset.currentItem) {
            items[i].style.display = 'flex';
          }
        });

        if (data.count === 0 && checkoutButton.hasClass('menu-checkout--items')) {
          checkoutButton.removeClass('menu-checkout--items');
          checkoutButton.addClass('menu-checkout--empty');
        }

        li.remove();
      }
    });

    e.preventDefault();
  });
};

const closeMenuCheckoutWhenClickOutside = () => {
  const checkoutButton = $('.menu-checkout');

  $(document).on('click', function (event) {
    if (!$(event.target).closest(checkoutButton).length) {
      closeCartMenu();
    }
  });
};

const closeMenuCheckoutWhenClick = () => {
  const checkoutCloseButton = $('.close_cart_menu');

  checkoutCloseButton.on('click', function () {
    closeCartMenu();
  });
};

const reloadMenuCheckout = () => {
  toogleMenuCheckoutWhenClick();
  closeMenuCheckoutWhenClick();
  removeFromCartWhenClick();
};

const showAddedItem = () => {
  const checkoutButton = $('.menu-checkout');
  checkoutButton.removeClass('menu-checkout--items');
  checkoutButton.removeClass('menu-checkout--empty');
  checkoutButton.addClass('menu-checkout--model');

  const showCartButton = $('.close_item_show_cart');
  showCartButton.on('click', function () {
    checkoutButton.removeClass('menu-checkout--model');
    checkoutButton.addClass('menu-checkout--items');
  });
};

const addToCartWhenClick = () => {
  $('body').on('click', '.add_cart_button', function (e) {
    e.preventDefault();
    const url = $(this).attr('href');
    showLoading();

    $.getJSON(url, function (data) {
      const checkoutButton = $('.menu-checkout');
      const items = $('.add_cart_button');

      // Hidden button when add item to cart
      // e.target.parentElement.style.display = 'none';

      items.each((i) => {
        if (items[i].dataset.currentItem === e.target.dataset.currentItem) {
          items[i].style.display = 'none';
        }
      });

      checkoutButton.html(data.render);
      checkoutButton.attr('data-item', data.count);

      reloadMenuCheckout();
      showAddedItem();
    })
      .done(function () {
        stopLoading();
      })
      .fail(function () {
        stopLoading();
      });

    e.preventDefault();
  });
};

const disableButtonWhenItemIsOnCart = () => {
  const buttonContainer = $('.add_cart_button');

  buttonContainer.each((e) => {
    if (buttonContainer[e].dataset.showButton === 'true') {
      buttonContainer[e].style.display = 'none';
    }
  });
};

const initializeMenuCheckout = () => {
  toogleMenuCheckoutWhenClick();
  closeMenuCheckoutWhenClick();
  closeMenuCheckoutWhenClickOutside();
  removeFromCartWhenClick();
};

export {
  disableButtonWhenItemIsOnCart,
  initializeMenuCheckout,
  addToCartWhenClick
};



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/common/cart.js